import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  PopoverAnchor,
  useMergeRefs,
} from '@chakra-ui/react';
import { IconButton } from '@diamond/shared/ui';
import { Cancel, SearchOutlined } from '@mui/icons-material';
import { forwardRef } from 'react';

import { useAutocompleteContext } from './AutocompleteContext';

export const AutocompleteInput = forwardRef<
  HTMLInputElement,
  React.ComponentPropsWithoutRef<typeof Input>
>((props, forwardedRef) => {
  const { getInputProps, keyword, clearKeyword, inputRef } =
    useAutocompleteContext();

  const ref = useMergeRefs(inputRef, forwardedRef);

  return (
    <PopoverAnchor>
      <InputGroup mb={{ base: 'unset', lg: 4 }} mx={1}>
        <InputLeftElement
          pointerEvents="none"
          children={
            <SearchOutlined
              sx={{
                color: '#999999',
              }}
            />
          }
        />
        <Input
          ref={ref}
          autoComplete="off"
          type="text"
          placeholder="Cari Produk"
          bgColor="white"
          borderColor="#999999"
          aria-label="search-keyword"
          {...getInputProps(props)}
        />
        {keyword ? (
          <InputRightElement
            children={
              <IconButton
                onClick={clearKeyword}
                name="Cancel Button"
                variant="unstyled"
                aria-label="Clear"
                icon={<Cancel style={{ color: '#9c9c9c' }} />}
              />
            }
          />
        ) : null}
      </InputGroup>
    </PopoverAnchor>
  );
});

AutocompleteInput.displayName = 'AutocompleteInput';
